"use client";

import React from "react";
import { cn } from "utils";

interface AppVersionUpdateModalContentProps {
  /** 是否允许关闭弹窗；false 时隐藏 Maybe Later */
  canClose?: boolean;
  onMaybeLater: () => void;
  onUpdateNow: () => void;
}

export const AppVersionUpdateModalContent: React.FC<
  AppVersionUpdateModalContentProps
> = ({ canClose = true, onMaybeLater, onUpdateNow }) => (
  <div className="flex flex-col gap-6 px-6 pb-3 pt-6 max-w-[calc(100vw-72px)]">
    <div className="flex flex-col gap-2">
      <p className="headline_regular_s text-content_primary">
        {"A new version is here"}
      </p>
      <p className="body_m text-content_secondary">
        {
          "We've improved performance and fixed a few bugs. Update now for a smoother experience."
        }
      </p>
    </div>
    <div className="flex justify-end gap-2">
      {canClose ? (
        <button
          type="button"
          className={cn("button sm_button secondary_button button_m min-w-20")}
          onClick={onMaybeLater}
          data-openreplay-label="AppVersionUpdate · Maybe Later"
        >
          {"Maybe Later"}
        </button>
      ) : null}
      <button
        type="button"
        className={cn("button sm_button primary_button button_m min-w-20")}
        onClick={onUpdateNow}
        data-openreplay-label="AppVersionUpdate · Update now"
      >
        {"Update now"}
      </button>
    </div>
  </div>
);
